import {gql} from "@apollo/client";
export const GENERATE_PARCEL_DOWNLOAD_REPORT_FOR_WMS = gql`
    mutation GenerateParcelDownloadReportForWMS($filters: OrderFiltersTypeInput, $timezone: String, $siteType: String!) {
        generateParcelDownloadReportForWMS(filters: $filters, timezone: $timezone, siteType: $siteType)
    }
`;

export interface GenerateParcelDownloadReportForWMSResponse {
    generateParcelDownloadReportForWMS: string;
}

export interface GenerateParcelDownloadReportForWMSVariables {
    filters?: any;
    timezone?: string;
    siteType: string;
}

